import firebase from "firebase";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyBD3_2YYeSFDPdA28AP87KRIYAq6_AFfa0",
    authDomain: "tindereth.firebaseapp.com",
    databaseURL: "https://tindereth.firebaseio.com",
    projectId: "tindereth",
    storageBucket: "tindereth.appspot.com",
    messagingSenderId: "772500294871",
    appId: "1:772500294871:web:07339ccfa990375021f492",
    measurementId: "G-5DQJT1BRVX"
};


const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();

export default db;